export default "__VITE_ASSET__9bf65dc6__"